import { Injectable, Signal } from '@angular/core';
import { IDeliveryAddressModel, IDeliveryData, IDeliveryModel, IHttpResponse, ITimeTableItem } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { DeliveryActions, DeliverySelectors, IDeliveryState } from '../store';

@Injectable({
  providedIn: 'root'
})
export class DeliveryStore extends StateAccessService<IDeliveryState> {
  readonly state$: Observable<IDeliveryState>;

  readonly data$$: Signal<IDeliveryData>;
  readonly model$$: Signal<IDeliveryModel>;

  readonly timetable$$: Signal<ITimeTableItem[]>;

  constructor() {
    super();
    this.model$$ = this.stateFacade.selectSignal$(DeliverySelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(DeliverySelectors.data);
    this.timetable$$ = this.stateFacade.selectSignal$(DeliverySelectors.timeTable);
  }

  dispatchDeliveryReset() {
    this.stateFacade.dispatch(DeliveryActions.reset());
  }
  dispatchDeliveryLoad() {
    this.stateFacade.dispatch(DeliveryActions.load());
  }
  dispatchDeliveryLoadSuccess({ model, data }: { model: IDeliveryModel; data: IDeliveryData }) {
    this.stateFacade.dispatch(DeliveryActions.loadSuccess({ model, data }));
  }
  dispatchDeliverySubmit() {
    this.stateFacade.dispatch(DeliveryActions.submit());
  }
  dispatchDeliverySubmitSuccess({ model, data }: { model: IDeliveryModel; data: IDeliveryData }) {
    this.stateFacade.dispatch(DeliveryActions.submitSuccess({ model, data }));
  }
  dispatchLoadTimeTable() {
    this.stateFacade.dispatch(DeliveryActions.loadTimeTable());
  }
  dispatchLoadTimeTableSuccess({ model, data }: { model: IDeliveryAddressModel; data: IDeliveryData }) {
    this.stateFacade.dispatch(DeliveryActions.loadTimeTableSuccess({ model, data }));
  }
  dispatchLoadTimeTableFailure(error: IHttpResponse<IDeliveryData>) {
    this.stateFacade.dispatch(DeliveryActions.loadTimeTableFailure({ error }));
  }
}
